import * as React from 'react';
import { observer } from 'mobx-react';
import { CardPaymentMethodViewModel } from './card-payment-method-view-model';
import { ZipCodeInput } from '../../../WebGiving/components/zipcode-input';
import { CardNumberInput } from '../../../WebGiving/components/card-number-input/card-number-input';
import { CvvInput } from '../../../WebGiving/components/cvv-input/cvv-input';
import { ExpiryDateInput } from '../../../WebGiving/components/expiry-date-input';
import { SupportedCardBrands } from '../../../WebGiving/components/supported-card-brands/supported-card-brands';
import { supportedLabel, colZipcode, supportedCardsWrapper } from './card-payment-method.less';
import { getSupportedCardIconParams } from '../../../WebGiving/utils/card-utils';

@observer
export class CardPaymentMethod extends React.Component<{ vm: CardPaymentMethodViewModel }> {
	render() {
		const { vm } = this.props;
		return (
			<div data-pp-at-target="Enter Credit Card page">
				<div className="row">
					<div className="col-sm-8">
						<CardNumberInput formControlId="card-number" value={vm.cardNumber} acceptanceTestTargetId="Credit Card" />
					</div>
					<div className="col-sm-4 hidden-xs">
						<div role="presentation">
							<span className={supportedLabel}>Supported</span>
							<SupportedCardBrands
								brandKeys={vm.supportedCardBrandKeys}
								iconParams={getSupportedCardIconParams(true)}
								wrapperClassName={supportedCardsWrapper}
							/>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-sm-4 col-xs-6">
						<ExpiryDateInput formControlId="expiry-date" value={vm.cardExpiryDate} acceptanceTestTargetId="Expiry date" />
					</div>
					<div className="col-sm-4 col-xs-6">
						<CvvInput formControlId="cvv" value={vm.cvv} acceptanceTestTargetId="Credit Card CVV" />
					</div>
					<div className={'col-sm-4 col-xs-6 ' + colZipcode}>
						<ZipCodeInput value={vm.zipCode} formControlId="zip-code" label={vm.zipCodeLabel} acceptanceTestTargetId="Zip Code" />
					</div>
				</div>
			</div>
		);
	}
}
